import { SectionNameEnum } from '@app/enums';
import { CmsHomepageState } from '@app/state/slices/cms-homepage';

export const sectionToStateKeyMap: Partial<Record<SectionNameEnum, keyof CmsHomepageState>> = {
    [SectionNameEnum.HeroSection]: 'heroSection',
    [SectionNameEnum.DestinationSuggestionsSection]: 'destinationSuggestions',
    [SectionNameEnum.HorizontalBanner]: 'horizontalBanner',
    [SectionNameEnum.FeaturedAccommodationsSection]: 'featuredAccommodations',
};
